import { FC, useState } from 'react'
import cx from 'classnames'

import * as SC from './styled'

type Item = {
  title: string
  text?: string | string[]
  texts?: Array<string>
}

export type AdsTypesProps = {
  className?: string
  items: Array<Item>
  texts?: {
    seeLess?: string
    seeMore?: string
  }
}

const AdsTypes: FC<AdsTypesProps> = ({ className, items, texts }) => {
  const [expandedIndices, setExpandedIndices] = useState<Set<number>>(new Set())

  const toggleExpanded = (idx: number) => {
    setExpandedIndices((prev) => {
      const next = new Set(prev)
      if (next.has(idx)) next.delete(idx)
      else next.add(idx)
      return next
    })
  }

  return (
    <SC.AdsTypes className={cx('AdsTypes', className)}>
      <SC.TypesList>
        {items.map((item, index) => {
          const hasSingleText = typeof item.text === 'string'
          const arrayTexts = Array.isArray(item.text)
            ? item.text
            : item.texts ?? []
          const isExpanded = expandedIndices.has(index)
          const visibleTexts = isExpanded ? arrayTexts : arrayTexts.slice(0, 3)
          const toggleLabel = isExpanded ? texts?.seeLess : texts?.seeMore

          return (
            <SC.TypesListItem key={index}>
              <SC.Title>{item.title}</SC.Title>
              {hasSingleText && <SC.Text>{item.text as string}</SC.Text>}
              {visibleTexts.map((textItem, i) => (
                <SC.Text key={i}>{textItem}</SC.Text>
              ))}
              {arrayTexts.length > 3 && (
                <SC.TypesListItemButton onClick={() => toggleExpanded(index)}>
                  {toggleLabel}
                </SC.TypesListItemButton>
              )}
            </SC.TypesListItem>
          )
        })}
      </SC.TypesList>
    </SC.AdsTypes>
  )
}

export default AdsTypes
